// @flow

// force flow to type check this file - https://github.com/zapier/zapier/pull/31127
import React /* eslint-disable-line no-unused-vars */, {
  useState,
} from 'react';

import { Text, Typography } from '@zapier/design-system';
import { TrialWelcomeModal, useSize } from '@zapier/design-system-company';
import {
  isolateComponent,
  labelStyles,
  withModifier,
} from '@zapier/common-utils';

/** @jsx isolateComponent */

type Props = {
  /** Number of days remaining in the user's Company trial */
  daysRemaining: number,
};

const Styles = labelStyles(__filename, {
  root: {
    position: 'relative',
    textAlign: 'center',
    width: '100%',
  },

  link: {
    ...Typography.altText900,
    color: 'white',
    textDecoration: 'underline',
  },

  linkWrapper: size => [
    {
      marginTop: 5,
      position: 'relative',
      textAlign: 'center',
    },
    size &&
      withModifier(
        size,
        {
          large: {
            marginTop: 0,
            position: 'absolute',
            right: 0,
            top: 0,
          },
          medium: {},
          small: {},
        }[size]
      ),
  ],
});

const TrialInProgressBanner = (props: Props) => {
  const [welcomeModalIsOpen, setWelcomeModalIsOpen] = useState(false);
  const size = useSize();

  const daysRemainingText = `${props.daysRemaining} ${
    props.daysRemaining === 1 ? 'day' : 'days'
  } remaining`;

  return (
    <div css={Styles.root}>
      <Text color="white" type="altText900">
        You have <strong>{daysRemainingText}</strong> of your Zapier for
        Companies trial.
      </Text>

      <button
        css={Styles.linkWrapper(size)}
        onClick={() => setWelcomeModalIsOpen(true)}
      >
        <span css={Styles.link}>View Guide</span>
      </button>

      {welcomeModalIsOpen && (
        <TrialWelcomeModal
          initialView={1}
          onClose={() => setWelcomeModalIsOpen(false)}
          size={size}
        />
      )}
    </div>
  );
};

export default TrialInProgressBanner;
